import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';

import { styled, ClassNames } from '@kufox/mui/emotion';
import { queryPersistence } from '@kc/gbiz-base/lib/QueryPersistence';
import { Input, Tooltip } from '@kufox/mui';
import useTheme from '@kufox/mui/hooks/useTheme';
import { useTranslation } from '@tools/i18n';
import ArrowIcon from '../../Icon/ArrowIcon';
import { useLang } from '../../hookTool';
import { getInviteDiscount } from './service';

const Container = styled.div`
  color: ${(props) => props.theme.colors.body};
  font-size: ${(props) => props.theme.fonts.size.lg.fontSize};
`;

const LabelTitle = styled.div`
  margin-bottom: 4px;
  color: ${(props) => props.theme.colors.text60};
  &:hover {
    cursor: pointer;
    color: ${(props) => props.theme.colors.primary};
    '& span': {
      border-color: ${(props) => props.theme.colors.primary};
    }
  }
  & span {
    padding: 0 0 1px;
    border: dashed;
    border-color: color.border;
    border-width: 0 0 1px;
  }
  & svg {
    font-size: ${(props) => props.theme.fonts.size.lg.fontSize};
  }
`;

const StyledArrowIconUp = styled(ArrowIcon)`
  position: relative;
  top: 0.25em;
  transition: transform 0.35s;
`;

const StyledArrowIconDown = styled(ArrowIcon)`
  top: 0.15em;
  transform: rotate(180deg);
`;

const InputWrapper = styled.div`
  display: ${(props) => (props.show ? 'block' : 'none')};
`;

const DiscountText = styled.div`
  margin-top: 4px;
  color: ${(props) => props.theme.colors.primary};
  font-size: ${(props) => props.theme.fonts.size.lg.fontSize};
  line-height: 22px;
`;

export default function InviteCode(props = {}) {
  const {
    iconStyle,
    defaultExpand = true,
    showDiscount = false,
    onChange = _.noop,
    value,
    onBlur = _.noop,
    isNew = false,
    ...others
  } = props;
  const { t } = useLang();
  const { t: _t } = useTranslation('entrance');
  const theme = useTheme();
  const [show, setShow] = useState(defaultExpand);
  const [RCode, setRCode] = useState(value);
  const [disabled, setDisabled] = useState(false);
  const [discount, setDiscount] = useState('');
  const hasDiscount = showDiscount && discount;

  useEffect(() => {
    const persistenceRcode = queryPersistence.getPersistenceQuery('rcode');
    if (persistenceRcode) {
      setRCode(persistenceRcode);
      setDisabled(true);
      requstDiscount(persistenceRcode);
      setShow(true);
    }
  }, []);

  useEffect(() => {
    if (typeof onChange === 'function') {
      onChange(RCode);
    }
  }, [RCode]);

  const handleChange = useCallback((e) => {
    setRCode(e.target.value);
  }, []);

  const handleClickShow = () => {
    setShow(!show);
  };

  const requstDiscount = async (rcode) => {
    if (!showDiscount) return;
    const trimedRCode = typeof rcode === 'string' ? rcode.trim() : rcode;
    try {
      const { data, code, success } = await getInviteDiscount({ code: trimedRCode });
      if (code === '200' && success) {
        setDiscount(data);
      }
    } catch (err) {
      console.log(err, '---get discount err---');
    }
  };

  const handleBlur = () => {
    typeof onBlur === 'function' && onBlur();
    requstDiscount(RCode);
  };

  return (
    <ClassNames>
      {({ css }) => {
        const inputContainerClass = css`
          padding: 0 ${isNew ? '12px' : '16px'};
        `;
        const inputClass = css`
          font-size: ${theme.fonts.size.xl.fontSize};
        `;

        return (
          <Container theme={theme}>
            <LabelTitle onClick={handleClickShow}>
              <Tooltip title={t('referral.tips')} placement="top-start">
                <span style={{ fontSize: '12px' }}>{t('referral.msg')}</span>
              </Tooltip>
              {show ? <StyledArrowIconUp /> : <StyledArrowIconDown />}
            </LabelTitle>
            <InputWrapper show={show}>
              <Input
                disabled={disabled}
                style={{ width: '100%' }}
                value={RCode}
                type="text"
                onChange={handleChange}
                onBlur={handleBlur}
                classNames={{
                  container: inputContainerClass,
                  input: inputClass,
                }}
                {...others}
              />
            </InputWrapper>
            {hasDiscount ? (
              <DiscountText>{_t('newsignup.discount', { discount: `${discount}%` })}</DiscountText>
            ) : null}
          </Container>
        );
      }}
    </ClassNames>
  );
}
